import styled from 'styled-components';
import Link from 'components/Link';
import Spacer from 'components/Spacer';
import { Heading } from 'components/Typography';
import { getShorthandActionColor, getThemeColor } from 'utils/styled';
import { ActionButtonStyleProps } from './types';

export const Root = styled(Spacer).attrs({
  align: 'center',
  space: '9px',
})`
  background-color: #ecf1fc;
  border-radius: 10px;
  color: ${getThemeColor('black')};
  line-height: 1.33;
  width: 355px;
  padding: 12px 10px 12px 15px;
  box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.25);
  border-width: 1px;
  border-style: solid;
  border-color: ${({ $accentColor }) => getShorthandActionColor($accentColor)};
  ${({ theme }) => theme.typography.variants.label.default};
`;

export const Subheading = styled(Heading).attrs({
  level: 4,
})`
  font-weight: 400;
`;

// pushes the action all the way to the right with an auto left margin.  action button
// itself has a 24px margin representing the minimum space allowed between the
// text and the action
export const ActionContainer = styled.div`
  margin-right: 9px;

  // increase specificity to override margin applied by Spacer container
  && {
    margin-left: auto;
  }
`;

export const ActionButton = styled(Link).attrs({
  forwardedAs: 'button',
  elementType: 'button',
  typography: 'text',
  variant: 'button',
})<ActionButtonStyleProps>`
  color: ${({ $color }) => getShorthandActionColor($color)};
  margin-left: 24px;

  &[data-hovered='true'] {
    color: ${({ $color }) => getShorthandActionColor($color, 'dark')};
  }
`;
